module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-button', {
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("显示提示框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.showError
    }
  }, [_vm._v("显示错误提示框")]), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.showSuccess
    }
  }, [_vm._v("显示成功提示框")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3064d9c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblAlert/example/vblAlertExample.vue
// module id = 255
// module chunks = 0